// Structured Data for SEO - Local Business & Services

export const getLocalBusinessSchema = () => ({
  "@context": "https://schema.org",
  "@type": ["TouristAttraction", "LocalBusiness", "SportsActivityLocation"],
  "@id": "https://seapulsealbania.com/#organization",
  name: "SeaPulse Albania",
  alternateName: [
    "SeaPulse Boat Tours",
    "SeaPulse Durrës",
    "Sea Pulse Albania",
  ],
  url: "https://seapulsealbania.com",
  logo: "https://seapulsealbania.com/logo-light-bg.png",
  description:
    "Durrës' #1 boat tour company. Speedboat adventures, WWII shipwreck dives, secret beach escapes, luxury yacht charters and jet ski rentals on the Albanian Adriatic coast. Professional crew, modern fleet, instant online booking.",
  image: [
    "https://seapulsealbania.com/logo-light-bg.png",
    "https://seapulsealbania.com/images/speedboat/quicksilver4.jpeg",
    "https://seapulsealbania.com/images/speedboat/yacht5.jpeg",
  ],
  telephone: "+355-69-231-1606",
  email: "info@seapulsealbania.com",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Durrës Marina",
    addressLocality: "Durrës",
    addressRegion: "Durrës County",
    postalCode: "2001",
    addressCountry: "AL",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: "41.3245",
    longitude: "19.4564",
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],
      opens: "08:00",
      closes: "21:00",
    },
  ],
  priceRange: "€€",
  currenciesAccepted: "EUR",
  paymentAccepted: "Cash, Bank Transfer, PayPal",
  areaServed: [
    {
      "@type": "City",
      name: "Durrës",
      sameAs: "https://en.wikipedia.org/wiki/Durr%C3%ABs",
    },
    {
      "@type": "Country",
      name: "Albania",
      sameAs: "https://en.wikipedia.org/wiki/Albania",
    },
  ],
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: "5.0",
    reviewCount: "110",
    bestRating: "5",
    worstRating: "1",
  },
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Boat Tour & Sea Activity Services",
    itemListElement: [
      {
        "@type": "Offer",
        name: "Shipwreck Tour – QuickSilver 805",
        description:
          "90-minute guided boat tour to a real WWII shipwreck off the Albanian coast. Swimming & snorkeling included.",
        price: "65",
        priceCurrency: "EUR",
        url: "https://seapulsealbania.com/quicksilver-tour/tour-details",
        itemOffered: {
          "@type": "TouristTrip",
          name: "Shipwreck Tour Durrës Albania",
        },
      },
      {
        "@type": "Offer",
        name: "Extended Sea Experience Durrës",
        description:
          "120-minute extended sea adventure on the Adriatic — perfect for an immersive day on the water.",
        price: "65",
        priceCurrency: "EUR",
        url: "https://seapulsealbania.com/quicksilver-tour/tour-details",
        itemOffered: {
          "@type": "TouristTrip",
          name: "Extended Sea Experience Durrës Albania",
        },
      },
      {
        "@type": "Offer",
        name: "Boat Cruise Durrës Albania",
        description:
          "90-minute boat cruise on the Adriatic — 5 daily departures: Morning, Midday, Afternoon, Evening & Night.",
        price: "50",
        priceCurrency: "EUR",
        url: "https://seapulsealbania.com/quicksilver-tour/tour-details",
        itemOffered: {
          "@type": "TouristTrip",
          name: "Boat Cruise Durrës Albania",
        },
      },
      {
        "@type": "Offer",
        name: "Bayliner Water Sports Session",
        description:
          "30-minute water sports session for groups of 1–4 on our Bayliner boat.",
        price: "100",
        priceCurrency: "EUR",
        url: "https://seapulsealbania.com/bayliner-water-sports/tour-details",
        itemOffered: {
          "@type": "TouristTrip",
          name: "Bayliner Water Sports Durrës",
        },
      },
      {
        "@type": "Offer",
        name: "Luxury Yacht Charter",
        description:
          "Premium 4-hour private yacht cruise on the Adriatic. Perfect for weddings, corporate events & special occasions.",
        price: "800",
        priceCurrency: "EUR",
        url: "https://seapulsealbania.com/luxury-yacht",
        itemOffered: {
          "@type": "TouristTrip",
          name: "Luxury Yacht Charter Durrës Albania",
        },
      },
      {
        "@type": "Offer",
        name: "Jet Ski Rental",
        description:
          "Adrenaline-packed jet ski rental from 15 to 30 minutes on the Albanian Adriatic.",
        price: "60",
        priceCurrency: "EUR",
        url: "https://seapulsealbania.com/jet-ski",
        itemOffered: {
          "@type": "TouristTrip",
          name: "Jet Ski Rental Durrës Albania",
        },
      },
      {
        "@type": "Offer",
        name: "Secret Beach Escape",
        description:
          "4-hour private boat tour to hidden beaches along the Albanian Riviera, accessible only by sea.",
        price: "100",
        priceCurrency: "EUR",
        url: "https://seapulsealbania.com/unique-tours",
        itemOffered: {
          "@type": "TouristTrip",
          name: "Secret Beach Escape Durrës Albania",
        },
      },
    ],
  },
  sameAs: [
    "https://www.facebook.com/seapulsealbania",
    "https://www.instagram.com/seapulsealbania",
    "https://www.tripadvisor.com/seapulsealbania",
  ],
});

export const getFAQSchema = () => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "What boat tours are available in Durrës, Albania?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "SeaPulse Albania offers: Boat Cruise (90 min, €50/person), Extended Sea Experience (120 min, €65/person), Shipwreck Tour (90 min, €65/person), Secret Beach Escape (4 hours, €100/person), Relaxing Private Cruise (2 hours, €120/person), Bayliner Water Sports (30–60 min, from €100/group), Luxury Yacht Charter (from €800), and Jet Ski Rental (15–30 min, from €60).",
      },
    },
    {
      "@type": "Question",
      name: "How much does a boat tour in Durrës cost?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Boat tours in Durrës with SeaPulse Albania start from €50 per person for the Boat Cruise (90 min). The Extended Sea Experience is €65/person (120 min). The Secret Beach Escape is €100/person (4 hours). Luxury Yacht Charter starts from €800 for a private group.",
      },
    },
    {
      "@type": "Question",
      name: "Do I need to book in advance?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Yes, advance booking is strongly recommended, especially in summer (June–September). You can book online at seapulsealbania.com or contact us via WhatsApp at +355 69 231 1606.",
      },
    },
    {
      "@type": "Question",
      name: "What is included in the boat tours?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "All SeaPulse Albania boat tours include a professional licensed skipper, life jackets, fuel, and safety equipment. Specific tours include extras such as snorkeling equipment, swimming stops, guided explanations, and more.",
      },
    },
    {
      "@type": "Question",
      name: "Is there a minimum number of people for a boat tour?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "QuickSilver speedboat tours require a minimum of 1 person and accommodate up to 11. Bayliner Water Sports sessions are for 1–4 people (flat group price). The luxury yacht accommodates up to 11 guests.",
      },
    },
    {
      "@type": "Question",
      name: "Where do the boat tours depart from?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "All SeaPulse Albania boat tours depart from Durrës Marina, located in Durrës, Albania (coordinates: 41.3245°N, 19.4564°E).",
      },
    },
  ],
});

export const getSpeedBoatTourSchema = () => ({
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  name: "Speedboat Tours in Durrës Albania",
  description:
    "Thrilling speedboat adventures along the Albanian Riviera. Explore a WWII shipwreck, hidden beaches, and crystal-clear Adriatic waters. Professional guides, modern QuickSilver 805 boat.",
  provider: {
    "@type": "Organization",
    name: "SeaPulse Albania",
    url: "https://seapulsealbania.com",
  },
  touristType: ["Adventure Seekers", "Families", "Couples", "History Lovers"],
  offers: {
    "@type": "Offer",
    price: "50",
    priceCurrency: "EUR",
    availability: "https://schema.org/InStock",
    url: "https://seapulsealbania.com/quicksilver-tour/tour-details",
  },
  itinerary: {
    "@type": "ItemList",
    itemListElement: [
      {
        "@type": "TouristDestination",
        name: "Durrës Marina",
        description: "Departure point in the heart of Durrës",
      },
      {
        "@type": "TouristDestination",
        name: "WWII Shipwreck Site",
        description:
          "Explore a real World War II shipwreck off the Albanian coast",
      },
      {
        "@type": "TouristDestination",
        name: "Albanian Riviera Hidden Beaches",
        description:
          "Secret coves and pristine beaches accessible only by boat",
      },
    ],
  },
});

export const getFishingTourSchema = () => ({
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  name: "Sea Tours in Albania",
  description:
    "Unique sea experiences on the Albanian Adriatic. Group water sports, private cruises, and secret beach escapes along the Albanian Riviera.",
  provider: {
    "@type": "Organization",
    name: "SeaPulse Albania",
    url: "https://seapulsealbania.com",
  },
  touristType: ["Families", "Couples", "Groups", "Nature Lovers"],
  isAccessibleForFree: false,
});

export const getBreadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: item.name,
    item: `https://seapulsealbania.com${item.path}`,
  })),
});

export const getWebsiteSchema = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": "https://seapulsealbania.com/#website",
  url: "https://seapulsealbania.com",
  name: "SeaPulse Albania",
  description: "Premier boat tour agency in Durrës, Albania",
  publisher: {
    "@id": "https://seapulsealbania.com/#organization",
  },
  potentialAction: {
    "@type": "SearchAction",
    target: {
      "@type": "EntryPoint",
      urlTemplate: "https://seapulsealbania.com/search?q={search_term_string}",
    },
    "query-input": "required name=search_term_string",
  },
});
